import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Trolley: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 21"
      fill="none"
    >
      <path
        d="M9.31785 10.1805L8.21666 4.18052C8.10392 3.5662 8.57566 3 9.20023 3H21.7998C22.4243 3 22.8961 3.5662 22.7833 4.18052L21.6821 10.1805C21.595 10.6552 21.1812 11 20.6986 11H10.3014C9.81876 11 9.40498 10.6552 9.31785 10.1805Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M1 2.89655L1.29703 2.60075C2.4215 1.48095 4.3397 2.054 4.66566 3.60711L6.34655 11.6162C6.63808 13.0053 7.86322 14 9.28259 14H22"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="10.5" cy="18.5" r="2.5" fill={color} />
      <circle cx="19.5" cy="18.5" r="2.5" fill={color} />
    </svg>
  );
};

export default Trolley;
